import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/neanderthal_website/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/neanderthal_website/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Roboto_Condensed\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/src/components/Matomo/MatomoTrackPageView.tsx");
;
import(/* webpackMode: "eager" */ "/opt/neanderthal_website/frontend/src/styles/style.scss");
